import { render, staticRenderFns } from "./prpItemForm.vue?vue&type=template&id=c00b84a8"
import script from "./prpItemForm.vue?vue&type=script&lang=js"
export * from "./prpItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports